module.exports = __webpack_public_path__ + "img/builder-28.3f8184a8.jpg";